import React from 'react';
import MostrarPlanes from './MostrarPlanes';
import ContenedorAnimacion from './ContenedorAnimacion';

const Planes: React.FC<{ id: string }> = ({ id }) => {
    return (
        <section id={id} className="bg-white pt-[60px] min-h-screen">
            <div className="pt-8 pb-4 px-4 mx-auto max-w-screen-2xl text-center">
                <ContenedorAnimacion animation='slideInLeft' duration={800} delay={1} className="">
                    <div className="mx-auto max-w-screen-2xl">
                        <h2 className="font-metropolis mb-4 text-4xl tracking-tight font-regular text-gray-900 ">Planes</h2>
                        <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Descubrí nuestros variados planes diseñados para cubrir todas tus necesidades de cobertura y bienestar.</h3>
                    </div> 
                </ContenedorAnimacion>
            </div>
            <div className="p-2 flex flex-col justify-center items-center xs:items-evenly md:w-full lg:w-full xl:w-full 2xl:w-full">
                <MostrarPlanes />
            </div>
        </section>
    );
};

export default Planes;